import React from "react";
import { FirebaseAuthUI } from "@src/auth/components/FirebaseAuthUi";
import Image from "next/legacy/image";
import { useAuth } from "@src/common/hooks/useAuth";
import { useRouter } from "next/router";
import commonRoutes from "@src/common/lib/routing/commonRoutes";
import { Loading } from "@src/index";

type Props = {};

const LoginPage = ({}: Props) => {
  const router = useRouter();
  const { authLoading, isAuthenticated } = useAuth();

  if (isAuthenticated) {
    router.push(commonRoutes.default);
    return <Loading loading={true}></Loading>;
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-paper px-6">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-accentSoft opacity-60 blur-3xl"
      />
      <div className="relative z-10 flex w-full max-w-md flex-col items-center">
        <div className="mb-8 flex items-center gap-3">
          <Image
            src={"/courielogo.png"}
            alt="Courie Logo"
            width={30}
            height={30}
          />
          <span className="text-xl font-semibold text-ink">Courie</span>
        </div>
        <h1 className="text-center text-3xl font-bold tracking-tight text-ink">
          Welcome
        </h1>
        <p className="mt-2 text-center text-sm text-muted">
          Sign in to manage your courier operation.
        </p>
        <div className="courie-auth-widget mt-8 w-full rounded-2xl bg-white p-8 shadow-3xl">
          <FirebaseAuthUI authLoading={authLoading} />
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
